import { useCallback } from 'react';
import axiosInstance from '../api/axios';
import { API_ENDPOINTS } from '../api/endpoints';

/**
 * Team providers for queue assignment — GET /team/providers.
 * Queue `provider_ids` are team-member **user_ids** (see MODULE_API_PLAN.md O4).
 */
export interface ProviderOption {
  user_id: string;
  name: string;
}

export const useProviders = () => {
  const getProviders = useCallback(async (): Promise<ProviderOption[]> => {
    const res = await axiosInstance.get(API_ENDPOINTS.GET_TEAM_PROVIDERS);
    const rows: any[] = res.data?.data ?? [];
    return rows.map((r) => ({
      user_id: r.user_id ?? r.id,
      name: r.display_name || r.user?.display_name || r.user?.phone_number || 'Provider',
    }));
  }, []);

  return { getProviders };
};
